module.exports = ".action-button {\n  background-color: #fecc00;\n  color: #000;\n  font-size: 12px;\n  font-weight: bold;\n  letter-spacing: 0.3px;\n  padding: 7px 30px;\n  margin-left: 2px;\n  margin-right: 2px;\n}\n\n.breadcrumb {\n  padding: 0px 0px !important;\n  margin-bottom: 20px;\n  list-style: none;\n  background-color: #84cbd9;\n  border-radius: 4px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/work-order/new-work-order/new-work-order.component.scss
// module id = ./src/app/system/work-order/new-work-order/new-work-order.component.scss
// module chunks = main